export const MIN_SCALE = 0.05
export const MAX_SCALE = 50

export function clampScale(s: number, min = MIN_SCALE, max = MAX_SCALE): number {
  return Math.min(max, Math.max(min, s))
}

export function stepScale(
  current: number,
  factor: number,
  min = MIN_SCALE,
  max = MAX_SCALE,
): number {
  return clampScale(current * factor, min, max)
}
